module.exports =
  FIELD_NAME_SEND_STATUS: '_send_status'
  FIELD_NAME_SEND_ERROR: '_send_error'

  SEND_STATUS_SENDING: 'sending'
  SEND_STATUS_FAILURE: 'failure'